import React, { PureComponent } from "react";
import * as colors from "../../helpers/constants/colors";
import Icon from "../Icon";
import Button from "../Button";

import { trackerActions } from "../../modules/tracker";
import { ResultsEvents } from "../../modules/tracker/event-names";
import { connect } from "react-redux";

class NextSteps extends PureComponent {
    componentDidMount() {
        this.props.trackEvent(ResultsEvents.DID_NAVIGATE_TO_NEXT_STEPS);
    }

    render() {
        return (
            <div
                style={{
                    width: "100vw",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <div style={{ order: 1, width: "60%", margin: "20px auto" }}>
                    <h2>What's Next?</h2>
                </div>
                <div
                    style={{
                        order: "2",
                        margin: "40px auto",
                        width: "80%",
                        height: "275px",
                        border: `1px solid ${colors.greys.palette.medGrey}`,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <div
                        style={{
                            height: "80px",
                            width: "115px",
                            margin: "-40px auto",
                            background: colors.white,
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >
                        <div
                            style={{
                                margin: "auto",
                                width: "80px",
                                height: "80px",
                                borderRadius: "80px",
                                background: colors.primary,
                                display: "flex"
                            }}
                        >
                            <Icon
                                icon={["far", "copy"]}
                                size="3x"
                                style={{
                                    color: colors.white,
                                    margin: "auto"
                                }}
                            />
                        </div>
                    </div>
                    <div
                        style={{
                            margin: "50px auto 10px auto",
                            height: "40px"
                        }}
                    >
                        <h2 style={{ color: colors.secondary }}>
                            Add Pages & Retest
                        </h2>
                    </div>
                    <div
                        style={{
                            margin: "10px auto",
                            background: colors.secondary,
                            height: "1px",
                            width: "75px"
                        }}
                    />
                    <div
                        style={{
                            margin: "10px auto",
                            maxWidth: "80%"
                        }}
                    >
                        <h5 className="muted">
                            Select pages from this test to keep and upload pages
                            or competitor pages to retest and see which will
                            win.
                        </h5>
                    </div>
                    <div
                        style={{
                            margin: "10px auto",
                            height: "40px"
                        }}
                    >
                        <Button
                            onClick={() => {
                                this.props.trackEvent(
                                    ResultsEvents.DID_SELECT_NEXT_STEP,
                                    {
                                        step_selected: "Add Pages"
                                    }
                                );
                            }}
                            color="primary"
                        >
                            Add Pages
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties))
    };
};

export default connect(
    null,
    mapDispatchToProps
)(NextSteps);



// WEBPACK FOOTER //
// ./src/components/Results/NextSteps.js